import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OnboardingVideoComponent } from 'libs/onboarding/src/lib/onboarding-modal/steps/onboarding-video/onboarding-video.component';
import { SiteSetupComponentService, StepNumberEnum } from '../site-setup/site-setup.component.service';
import { siteSetupVideos } from '../site-setup-videos';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-welcome',
  imports: [CommonModule, TranslateModule, OnboardingVideoComponent],
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.scss',
})
export class OverviewComponent {
  private readonly service = inject(SiteSetupComponentService);
  public vm = this.service.viewModel;

  public StepNumberEnum = StepNumberEnum;
  public overviewVideo = siteSetupVideos[0];

  public next(): void {
    this.service.beginContract();
  }
}
